const ADJECTIVES = [
  "cloud-based",
  "blockchain",
  "Web 3.0",
  "responsive",
  "GDPR-compliant",
  "HIPAA-compliant",
  "high-performance",
  "dynamic-range",
  "socially-conscious",
  "ultra-HD",
  "eco-friendly",
  "green",
  "IOT-enabled",
  "plug-and-play",
  "enterprise",
  "organic",
  "free-range",
  "biomedical",
  "handheld",
  "free-to-play",
  "high-throughput",
  "A.I.",
  "B2B",
  "bespoke",
  "pharmaceutical",
  "gigabit",
  "augmented reality",
  "quantum",
];
const NOUNS = [
  ["funeral systems", "funeral system"],
  ["information systems", "information system"],
  ["board games", "board game"],
  ["hardware", "hardware"],
  ["software", "software"],
  ["consulting services", "consulting service"],
  ["trucks", "truck"],
  ["cars", "car"],
  ["weapons", "weapon"],
  ["cameras", "camera"],
  ["furniture", "furniture"],
  ["juice pressers", "juice presser"],
  ["blenders", "blender"],
  ["jackets", "jacket"],
  ["sunglasses", "sunglass"],
  ["Bluetooth speakers", "Bluetooth speaker"],
  ["fitness trackers", "fitness tracker"],
  ["VR headsets", "VR headset"],
  ["cannabis", "cannabis"],
  ["banking", "banking"],
  ["scooters", "scooter"],
  ["gene editing", "gene editing"],
  ["networking services", "network service"],
  ["social networks", "social network"],
  ["hoodies", "hoodie"],
  ["marketplaces", "marketplace"],
  ["chatbots", "chatbot"],
];
const FORMATTERS = [
  (a, s, p) => `${a} ${p}`,
  (a, s, p) => `${a} ${p}`,
  (a, s, p) => `${a} ${p}`,
  (a, s, p) => `${a} ${p}`,
  (a, s, p) => `${a} ${p}`,
  (a, s, p) => `${a} ${p}`,
  (a, s, p) => `${a} ${p}`,
  (a, s, p) => `${a} ${p}`,
  (a, s, p) => `Uber for ${a} ${p}`,
  (a, s, p) => `Airbnb for ${a} ${p}`,
  (a, s, p) => `Tinder for ${a} ${p}`,
  (a, s, p) => `${a} ${p} as a service`,
  (a, s, p) => `${a} ${p} on demand`,
  (a, s, p) => `${a} ${s} delivery`,
  (a, s, p) => `${a} ${p} for millennials`,
  (a, s, p) => `${a} ${p} powered by ML`,
];

export default function generateProductName() {
  const randomAdjective = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const [randomNounPlural, randomNounSingular] = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  const randomFormatter = FORMATTERS[Math.floor(Math.random() * FORMATTERS.length)];
  return randomFormatter(randomAdjective, randomNounSingular, randomNounPlural);
}
